import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles, Grid, Button } from '@material-ui/core';
import { Add } from '@material-ui/icons'
import { listTasks, listTaskTypes } from '../../actions/tasks'
import DataPanels from './DataPanels'
import Tasks from './Tasks'
import styles from 'components/styles'
import language from 'utils/vast-languagepack'

export default connect(
  state => ({
    tasksLoaded: state.loadStatus.tasks,
    taskTypesLoaded: state.loadStatus.taskTypes,
  }),
  dispatch =>
    bindActionCreators(
      {
        listTasks,
        listTaskTypes,
      },
      dispatch,
    ),
)(
  withStyles(styles)(
    class TasksPage extends Component {
      render() {
        const {
          listTasks,
          listTaskTypes,
          tasksLoaded,
          taskTypesLoaded,
          history,
          classes,
        } = this.props

        if (!tasksLoaded) {
          listTasks()
        }

        if (!taskTypesLoaded) {
          listTaskTypes()
        }

        return (
          <div style={{marginTop: '-24px'}} className={classes.mobilePadding}>
            <Grid container justify='space-between'>
              <Grid item>
                <h1 style={{marginBlockStart: '0.67em', marginBlockEnd: '0.3em', marginLeft: '8px', color: '#014c94'}}>{language.task.taskHeader}</h1>
              </Grid>
              <Grid item style={{marginBlockStart: '0.67em', marginBlockEnd: '0.3em', marginRight: '8px'}}>
                <Button
                  style={{marginBlockStart: '0.67em', marginBlockEnd: '0.3em', borderRadius: '20px'}}
                  className={classes.addButton}
                  onClick={() => history.push('tasks/new')}
                >
                  <Add /> {language.task.add.labels.createTask}
                </Button>
              </Grid>
            </Grid>            
            <Grid
              className={classes.tasksPageGridMobileWidth}
              container
              spacing={16}
              style={{marginTop: '0px'}}
              // style={{ width: '100%', margin: 0 }}
            >
              <Grid item xs={12}>
                <DataPanels />
              </Grid>
              <Grid
                item
                xs={12}
                // style={{ height: '500px' }}
                // className={classes.tasksMobileWidth}
              >
                <Tasks history={history} />
              </Grid>
            </Grid>
          </div>
        );
      }
    },
  ),
)
